import { Directive, OnInit, OnChanges, ElementRef, Input, SimpleChanges } from '@angular/core';
import { AvatarProvider } from './avatar.provider';
import { Constants } from '../Constants';
import { Q } from  'ess-plugin-base';

@Directive({
    selector: 'img[avatar]',
    host: {
        '(onerror)': 'onError()'
    },
    exportAs: 'AvatarDirective'
})
export class AvatarDirective implements OnInit, OnChanges {

    @Input('avatar')
    avatar: string;

    @Input('username')
    username: string;

    @Input('color')
    color: string = "#006699";

    @Input('background')
    background: string = "#E8E8E8";

    constructor(private el: ElementRef, private provider: AvatarProvider) { }

    ngOnInit() {
        // this.el.nativeElement.src = 'https://ui-avatars.com/api?name=' + this.avatar;

        let w = (this.el.nativeElement.width) ? +this.el.nativeElement.width : 32;
        //this.el.nativeElement.src = this.getAvatar(this.avatar, w);
        this.getAvatar(this.avatar, w);
    }

    ngOnChanges(changes: SimpleChanges) {
        // this.el.nativeElement.src = 'https://ui-avatars.com/api?name=' + this.avatar;

        let w = (this.el.nativeElement.width) ? +this.el.nativeElement.width : 32;
        //this.el.nativeElement.src = this.getAvatar(this.avatar, w);
        this.getAvatar(this.avatar, w);
    }

    onError() {
        let w = (this.el.nativeElement.width) ? +this.el.nativeElement.width : 32;
        this.el.nativeElement.src = this.getAvatarOnError(this.avatar, w);
    }

    private getAvatar(name, size) {
        if (this.username) {
            this.el.nativeElement.src = Constants.protocol + Constants.identityServer + '/person/avatar?' +
            encodeURIComponent(Q.i('un')) + "=" + encodeURIComponent(Q.i(this.username));
            // ?un=' + ;
        }
        this.el.nativeElement.onerror = () => {
            // const w = window;
            // const d = document;
            name = name || '';
            size = size || 32;

            var colours = [
                "#1abc9c", "#2ecc71", "#3498db", "#9b59b6", "#34495e", "#16a085", "#27ae60", "#2980b9", "#8e44ad", "#2c3e50",
                "#f1c40f", "#e67e22", "#e74c3c", "#ecf0f1", "#95a5a6", "#f39c12", "#d35400", "#c0392b", "#bdc3c7", "#7f8c8d"
            ],

                nameSplit = String(name).toUpperCase().split(' '),
                initials, charIndex, colourIndex, canvas, context, dataURI;


            if (nameSplit.length == 1) {
                initials = nameSplit[0] ? nameSplit[0].charAt(0) : '?';
            } else {
                initials = nameSplit[0].charAt(0);  // + nameSplit[1].charAt(0);
            }

            if (window.devicePixelRatio) {
                size = (size * window.devicePixelRatio);
            }

            charIndex = (initials == '?' ? 72 : initials.charCodeAt(0)) - 64;
            colourIndex = charIndex % 20;
            canvas = document.createElement('canvas');
            canvas.width = size;
            canvas.height = size;
            context = canvas.getContext("2d");

            context.fillStyle = this.background || "#E8E8E8";         //colours[colourIndex - 1];
            context.fillRect(0, 0, canvas.width, canvas.height);
            context.font = Math.round(canvas.width / 2.25) + "px Arial";
            context.textAlign = "center";
            context.fillStyle = this.color || "#006699";      //"#FFF";
            context.fillText(initials, size / 2, size / 1.5);

            dataURI = canvas.toDataURL();
            canvas = null;

            this.el.nativeElement.src = dataURI;
        }; 
    }

    private getAvatarOnError(name, size) {
        name = name || '';
        size = size || 32;

        var colours = [
            "#1abc9c", "#2ecc71", "#3498db", "#9b59b6", "#34495e", "#16a085", "#27ae60", "#2980b9", "#8e44ad", "#2c3e50",
            "#f1c40f", "#e67e22", "#e74c3c", "#ecf0f1", "#95a5a6", "#f39c12", "#d35400", "#c0392b", "#bdc3c7", "#7f8c8d"
        ],

            nameSplit = String(name).toUpperCase().split(' '),
            initials, charIndex, colourIndex, canvas, context, dataURI;


        if (nameSplit.length == 1) {
            initials = nameSplit[0] ? nameSplit[0].charAt(0) : '?';
        } else {
            initials = nameSplit[0].charAt(0);  // + nameSplit[1].charAt(0);
        }

        if (window.devicePixelRatio) {
            size = (size * window.devicePixelRatio);
        }

        charIndex = (initials == '?' ? 72 : initials.charCodeAt(0)) - 64;
        colourIndex = charIndex % 20;
        canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        context = canvas.getContext("2d");

        context.fillStyle = this.background || "#E8E8E8";         //colours[colourIndex - 1];
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.font = Math.round(canvas.width / 2.25) + "px Arial";
        context.textAlign = "center";
        context.fillStyle = this.color || "#006699";      //"#FFF";
        context.fillText(initials, size / 2, size / 1.5);

        dataURI = canvas.toDataURL();
        canvas = null;

        return dataURI;
    }

}